import { useContext, useEffect, useState } from 'react'
import AdvancedSearchBlock from '../../components/AdvancedSearch'
import { LiaComments } from "react-icons/lia";
import { HiOutlineCurrencyRupee } from "react-icons/hi2"
import { GoBriefcase } from "react-icons/go";
import { LuFileUser } from "react-icons/lu";

import { LiaFileDownloadSolid } from "react-icons/lia";
import { DataProvider } from '../../store/ContextProvider';
import Loading from '../Loading';
import { fetchCandidatess } from '../../services/fetchCandidate';

function AdvancedSearch() {

  const { BeURL, showAlert } = useContext(DataProvider);
  const [showSearchOptions, setShowSearchOptions] = useState(true)
  const [candidates, setCandidates] = useState(null)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCandidates, setTotalCandidates] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const [comments, setComments] = useState([]);
  const [allcomments, setAllComments] = useState([]);
  const [viewingComment, setViewingComment] = useState(false);

  const [filterOptions, setFilterOptions] = useState({
    itemsPerPage: itemsPerPage || 10,
    currentPage: currentPage || 1,
    keyword: {},
    company: {},
    designation: {},

    selectedEducation: [],
    selectedGender: "",

    locationType: "",
    selectedCities: [],
    selectedState: "",
    selectedDistrict: "",
    enteredCity: "",
    includePreferredLocation: false,

    age: {},
    experience: {},
    salary: {},

    selectedNegotiableNoticePeriod: [],
    selectedNoticePeriod: [],
    lastWorkingDay: "",
    skills: [],

    resumeSearch: false,
    resumeAvailability: false,
    relocation: false,
    salaryStatus: false,
    excludeDisability: false
  })


  useEffect(() => {
    fetch(`${BeURL}/candidate/comments`, { credentials: "include" })
      .then(res => res.json())
      .then(data => {
        if (data.success) setAllComments(data.comments);
      });
  }, [])

  const handlePagination = (dir) => {
    if (dir === 'prev' && currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
    if (dir === 'next' && currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const renderExp = (exp) => {
    if (exp) {
      if (exp.year && exp.month) {
        return `${exp.year}y ${exp.month}m`
      }
      else if (exp.year) {
        return `${exp.year}y`
      }
      else if (exp.month) {
        return `${exp.month}m`
      }
      else {
        return '-'
      }
    }
    else {
      return '-'
    }
  }
  useEffect(() => {
    const fetchCandidate = async () => {

      await fetchCandidatess(BeURL, filterOptions, setCandidates, setTotalPages, setTotalCandidates, setLoading, setShowSearchOptions, showAlert)

    }

    fetchCandidate()

  }, [BeURL])

  const handleViewComment = (id) => {
    fetch(`${BeURL}/candidate/${id}/comments`, { credentials: "include" })
      .then(res => res.json())
      .then(data => {
        if (data.success) setComments(data.comments);
        setViewingComment(true);
      });


  }

  if (!candidates) return <Loading />

  return (
    <div className='my-4 min-h-[80vh] relative'>

      <h3 className='text-2xl font-semibold text-stone-950 text-center my-4 flex justify-center items-center gap-2'>
        <span className="material-symbols-outlined">
          manage_search
        </span>
        <>
          <span className="">Pro Search</span>
        </>
      </h3>


      <AdvancedSearchBlock showSearchOptions={showSearchOptions} setShowSearchOptions={setShowSearchOptions} setCandidates={setCandidates} itemsPerPage={itemsPerPage} currentPage={currentPage} setTotalPages={setTotalPages} setTotalCandidates={setTotalCandidates} setLoading={setLoading}
        filterOptions={filterOptions} setFilterOptions={setFilterOptions} />

      <div id='list-candidates'>
        <div className="overflow-y-auto bg-white rounded-xl shadow-lg max-w-[96vw] min-h-[55vh] max-h-[65vh] mx-auto">

          <div className="min-w-full divide-y divide-gray-200 relative">


            <div className=" relative">
              <div className="p-2 flex flex-col md:flex-row flex-wrap justify-center align-center gap-4 ">
                {(!loading && candidates && candidates.length > 0 ? (
                  candidates.map((c, idx) => {
                    const comment = allcomments.find(comment => comment.candidateId === c._id)

                    return (
                      <div
                        key={c.applicantID}
                        className={`rounded-lg border-[0.5px] shadow-lg transition overflow-hidden hover:shadow-md hover:border-slate-300 w-96 ${idx % 2 === 0 ? "bg-gray-50" : "bg-white"
                          }`}
                      >
                        <div className="relative z-50 ">
                          <span className={`${c.newResumeStatus &&
                            "absolute bg-primary-300 -rotate-[45deg] -top-[6px] -left-[14px] h-5 w-8"
                            }`} ></span>
                        </div>

                        <div className='flex justify-start items-center py-1 align-center px-2 '>
                          <div onClick={() => window.open(`/candidate/${c._id}`, "_blank")}>
                            <img className="h-[60px] rounded-full w-fit cursor-pointer"
                              title="View"
                              src={`https://ui-avatars.com/api/?name=${c.applicantName || c.applicantFullName}&background=e8eaff&color=2c25c4`}
                              alt="profile"
                            />
                          </div>
                          <div>
                            <p
                              className="px-4  text-lg text-primary-400 hover:text-primary-200 font-semibold cursor-pointer"
                              title="View"
                              onClick={() => window.open(`/candidate/${c._id}`, "_blank")}
                            >
                              {c.applicantName}
                            </p>

                            <p
                              className="px-4 pb-1 text-sm font-bold uppercase text-primary-400 hover:text-primary-200 cursor-pointer"
                              title="View"
                              onClick={() => window.open(`/candidate/${c._id}`, "_blank")}
                            >
                              {c.candidateID}
                            </p>
                          </div>

                        </div>


                        {/* Experience + CTC */}
                        <div className="flex gap-8 items-center px-4 py-1 text-sm text-gray-700">
                          <p className="flex items-center gap-1 font-medium">
                            <GoBriefcase /> {renderExp(c.experience)}
                          </p>
                          <p className="flex items-center gap-1 font-medium">
                            <HiOutlineCurrencyRupee className='text-base' />{" "}
                            {c.currentCTC?.amount ? `${c.currentCTC.amount} LPA` : "-"}
                          </p>
                        </div>

                        {/* Job details */}
                        <p className="px-4 py-1 text-sm text-gray-400 font-medium">
                          Job Title:{" "}
                          <span className="text-gray-700 font-semibold">
                            {c.experiences?.[0]?.jobTitle || "-"}
                          </span>
                        </p>
                        <p className="px-4 py-1 text-sm text-gray-400 font-medium">
                          Created On:{" "}
                          <span className="text-gray-700">{c.createdOn ? (new Date(c.createdOn).toLocaleDateString("en-GB")) : (c.createdAt ? (new Date(c.createdAt).toLocaleDateString("en-GB")) : "-")}</span>
                        </p>

                        <p className="px-4 py-1 text-sm text-gray-400 font-medium pb-2">
                          Notice Period:{" "}
                          <span className="text-gray-700">{c.noticePeriod || "-"}</span>
                        </p>

                        {/* Action icons */}
                        <div className="px-4 py-2 border-t flex justify-between text-sm">
                          <div className="flex gap-3 items-center text-gray-600 ">
                            <div className='flex items-center gap-1 cursor-pointer text-primary-400 hover:text-primary-300' title='Profile View Counts'>
                              <span className="material-symbols-outlined r text-xl">
                                visibility
                              </span><span>{c?.profileViewCount || 0}</span>
                            </div>
                            <div className='flex items-center gap-1' title='Resume View Counts'>
                              <LuFileUser className="text-base " />
                              <span>{c?.resumeViewCount || 0}</span>
                            </div>
                          </div>

                          <div className="flex gap-3 items-center text-gray-600">

                            <div className='flex items-center gap-1' title='Resume Download Counts'>
                              <LiaFileDownloadSolid className="text-lg " />
                              <span>{c?.resumeDownloadCount || 0}</span>
                            </div>
                            <div
                              className={` flex items-center gap-1 ${comment
                                ? "  text-primary-300 hover:text-primary-100 cursor-pointer"
                                : " text-gray-400 cursor-not-allowed"
                                }`}
                              onClick={() => handleViewComment(c._id)}
                              title={comment ? "View Comments" : "No Comments available"} >
                              <LiaComments
                                className={` text-lg `}
                                onClick={() => handleViewComment(c._id)}
                              />
                              <span>{comment?.comments.length || 0}</span>

                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <div className="min-h-[50vh] flex justify-center items-center">
                    {!loading ? <span className="text-center p-4">No data available!</span> :
                      <div>

                        <div className='min-h-[50vh] flex justify-center items-center'>
                          <div class="flex flex-row gap-2">
                            <div class="w-4 h-4 rounded-full bg-blue-700 animate-bounce [animation-delay:.7s]"></div>
                            <div class="w-4 h-4 rounded-full bg-blue-700 animate-bounce [animation-delay:.3s]"></div>
                            <div class="w-4 h-4 rounded-full bg-blue-700 animate-bounce [animation-delay:.7s]"></div>
                          </div>
                        </div>

                      </div>}
                  </div>
                ))}
              </div>
            </div>

            {/* {
              loading &&
              
            } */}

          </div>

          {/* for popup */}
          {
            comments.length > 0 && viewingComment && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-2xl w-full">
                  <h3 className="text-xl font-semibold mb-4">Comments</h3>
                  <div className="space-y-2 max-h-48 overflow-y-auto border p-2 rounded bg-gray-50">
                    {comments.length === 0 && <p className="text-sm text-gray-500">No comments yet</p>}
                    {comments.reverse().map((c, idx) => (
                      <div key={idx} className="p-2 border-b">
                        <p className="text-sm">{c.message}</p>
                        <p className="text-xs text-gray-500">
                          — {c.commentedByName} on {new Date(c.commentedOn).toLocaleString("en-GB")}
                        </p>
                      </div>
                    ))}
                  </div>
                  <button
                    onClick={() => setViewingComment(false)}
                    className="mt-4 bg-secondary-500 text-white px-4 py-2 rounded-lg hover:bg-secondary-400"
                  >
                    Close
                  </button>
                </div>
              </div>)
          }

        </div>

        {/* Pagination Controls */}
        <div className="max-w-[96vw] mx-auto my-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <label htmlFor="recordsPerPage" className="text-sm">Records per page:</label>
            <select
              id="recordsPerPage"
              value={itemsPerPage}
              onChange={e => setItemsPerPage(parseInt(e.target.value, 10))}
              className="ml-2 px-3 py-1 border rounded"
            >
              {[10, 20, 25, 50, 75, 100].map(n => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>
          <div className="text-sm">Total Candidates: {totalCandidates}+</div>
        </div>

        <div className="flex justify-center items-center gap-4">

          <span className={`p-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === 1 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            onClick={() => handlePagination('prev')}
            disabled={currentPage === 1}
          >
            chevron_left
          </span>

          <span>{currentPage} of {totalPages}+</span>

          <span className={`p-2 text-primary-400 material-symbols-outlined text-4xl ${currentPage === totalPages ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            onClick={() => handlePagination('next')}
            disabled={currentPage === totalPages}
          >
            chevron_right
          </span>

        </div>
      </div>

      {/* {
        loading && <FloatingLoading />
      } */}

    </div>
  )
}

export default AdvancedSearch